import React from 'react';
import config from 'config';
import LoadingPageContent from 'Components/LoadingPageContent';

export default class ConfigLoader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
        };

    }

    componentDidMount() {

        var requestOptions = {
            headers: {
                "Content-Type" : "application/json"
            }
        };

        if (config.configFile && !this.state.isLoaded) {
            fetch(config.configFile, requestOptions)
                .then(response => {
                    return response.text();
                })
                .then(response => {
                    var configuration = JSON.parse(response);
                    Object.assign(config, configuration);
                    this.setState({
                        isLoaded: true,
                        config, config
                    });
                })
                .catch(error => console.log(error));
        } else {
            this.setState({
                isLoaded: true
            })
        }
    }

    render() {

        return this.state.isLoaded === false ? (<LoadingPageContent />) : (this.props.ready());

    }
}